import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { css } from '@emotion/react';
import { customProperties } from '@commercetools-uikit/design-system';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { jsx } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getPadding = function getPadding(scale) {
  switch (scale) {
    case 'xs':
      return customProperties.spacingXs;

    case 's':
      return customProperties.spacingS;

    case 'm':
      return customProperties.spacingM;

    case 'l':
      return customProperties.spacingL;

    case 'xl':
      return customProperties.spacingXl;

    default:
      return 0;
  }
};

var Inset = function Inset(props) {
  return jsx("div", _objectSpread(_objectSpread({
    css: /*#__PURE__*/css("padding:", getPadding(props.scale), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Inset;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluc2V0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErQlkiLCJmaWxlIjoiaW5zZXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBmaWx0ZXJEYXRhQXR0cmlidXRlcyB9IGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L3V0aWxzJztcblxuZXhwb3J0IHR5cGUgVFNjYWxlID0gJ3hzJyB8ICdzJyB8ICdtJyB8ICdsJyB8ICd4bCc7XG5cbmNvbnN0IGdldFBhZGRpbmcgPSAoc2NhbGU/OiBUU2NhbGUpID0+IHtcbiAgc3dpdGNoIChzY2FsZSkge1xuICAgIGNhc2UgJ3hzJzpcbiAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdYcztcbiAgICBjYXNlICdzJzpcbiAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdTO1xuICAgIGNhc2UgJ20nOlxuICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ007XG4gICAgY2FzZSAnbCc6XG4gICAgICByZXR1cm4gdmFycy5zcGFjaW5nTDtcbiAgICBjYXNlICd4bCc6XG4gICAgICByZXR1cm4gdmFycy5zcGFjaW5nWGw7XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAwO1xuICB9XG59O1xuXG50eXBlIFRQcm9wcyA9IHtcbiAgc2NhbGU6IFRTY2FsZTtcbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG59O1xuXG5jb25zdCBJbnNldCA9IChwcm9wczogVFByb3BzKSA9PiAoXG4gIDxkaXZcbiAgICBjc3M9e2Nzc2BcbiAgICAgIHBhZGRpbmc6ICR7Z2V0UGFkZGluZyhwcm9wcy5zY2FsZSl9O1xuICAgIGB9XG4gICAgey4uLmZpbHRlckRhdGFBdHRyaWJ1dGVzKHByb3BzKX1cbiAgPlxuICAgIHtwcm9wcy5jaGlsZHJlbn1cbiAgPC9kaXY+XG4pO1xuY29uc3QgZGVmYXVsdFByb3BzOiBQaWNrPFRQcm9wcywgJ3NjYWxlJz4gPSB7XG4gIHNjYWxlOiAnbScsXG59O1xuSW5zZXQuZGlzcGxheU5hbWUgPSAnSW5zZXQnO1xuSW5zZXQuZGVmYXVsdFByb3BzID0gZGVmYXVsdFByb3BzO1xuXG5leHBvcnQgZGVmYXVsdCBJbnNldDtcbiJdfQ== */")
  }, filterDataAttributes(props)), {}, {
    children: props.children
  }));
};

Inset.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: _pt.oneOf(['xs', 's', 'm', 'l', 'xl']).isRequired,
  children: _pt.node
} : {};
var defaultProps = {
  scale: 'm'
};
Inset.displayName = 'Inset';
Inset.defaultProps = defaultProps;
var Inset$1 = Inset; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { Inset$1 as default, version };